export var ZoomOperation;
(function (ZoomOperation) {
    ZoomOperation[ZoomOperation["Increase"] = 0] = "Increase";
    ZoomOperation[ZoomOperation["Decrease"] = 1] = "Decrease";
})(ZoomOperation || (ZoomOperation = {}));
